import { render, staticRenderFns } from "./CNotificationsFromStore.vue?vue&type=template&id=a853b54a&"
import script from "./CNotificationsFromStore.vue?vue&type=script&lang=js&"
export * from "./CNotificationsFromStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports